import { request } from '../utils/request';

const fetchAnnualReviewReportApi = (hubId, params = {}) =>
  request.get(`/admin/hub/${hubId}/annual-review-report`, {
    params,
  });

export default fetchAnnualReviewReportApi;
